"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredFolders = exports.getChildFolders = void 0;

var _reselect = require("reselect");

var _Folders = require("FileManagerCore/selectors/Folders");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var getSearchQuery = function getSearchQuery(state) {
  return state.panel.getIn(['present', 'searchQuery']);
};

var getSelectedFolderFromPanel = function getSelectedFolderFromPanel(state) {
  return state.panel.getIn(['present', 'selectedFolder']);
};

var getSelectedFolderId = (0, _reselect.createSelector)([getSelectedFolderFromPanel], function (selectedFolder) {
  return selectedFolder && selectedFolder.get('id');
});
var getChildFolders = (0, _reselect.createSelector)([_Folders.getFolders, getSelectedFolderId], function (folders, selectedFolderId) {
  var parentId = !selectedFolderId ? null : selectedFolderId.toString();
  return folders.filter(function (folder) {
    return folder.get('parent_folder_id') === parentId;
  });
});
exports.getChildFolders = getChildFolders;
var getFilteredFolders = (0, _reselect.createSelector)([_Folders.getFolders, getSearchQuery], _FoldersAndFiles.getFilteredByKeyword);
exports.getFilteredFolders = getFilteredFolders;